<template>
  <vinnuskoli-page>
    <div class="page-title">Skoða umsókn</div>
    <h2 class="font-weight-normal">{{ data && data.name }}</h2>

    <div class="mb-2" v-if="data">
      <div class="d-flex" style="gap: 8px" aria-label="Aðgerðir á umsókn">
        <b-btn
          variant="success"
          v-if="
            availableStatuses[data.status].includes('ACCEPTED') &&
            loggedInUserHasAnyPermission('write_application') &&
            loggedInUserHasAnyPermission('write_approve_application')
          "
          @click.prevent="applicationApproveModal()"
        >
          <i class="fa fa-fw fa-check" style="color: #fff"></i>
          Samþykkja umsókn
        </b-btn>
        <b-btn
          variant="dark"
          v-if="
            data.status === 'SEMI_ACCEPTED' &&
            loggedInUserHasAnyPermission('write_application') &&
            loggedInUserHasAnyPermission('write_approve_application')
          "
          @click.prevent="applicationFinishModal()"
        >
          <i class="fa fa-fw fa-envelope"></i>
          Klára umsókn
        </b-btn>
        <b-btn
          variant="warning"
          v-if="
            availableStatuses[data.status].includes('REJECTED') &&
            loggedInUserHasAnyPermission('write_application') &&
            loggedInUserHasAnyPermission('write_approve_application')
          "
          @click.prevent="applicationRejectModal()"
        >
          <i class="fa fa-fw fa-remove"></i>
          Hafna umsókn
        </b-btn>
        <b-btn
          variant="danger"
          v-if="
            ['ACCEPTED', 'SEMI_ACCEPTED', 'COMPLETED', 'IN_PROGRESS', 'IN_PROGRESS_APPROVED'].includes(data.status) &&
            loggedInUserHasAnyPermission('write_approve_application')
          "
          @click.prevent="applicationResetFullModal()"
        >
          <i class="fa fa-fw fa-undo"></i>
          Endurstilla umsókn
        </b-btn>

        <b-dropdown
          variant="info"
          text="Aðrar stöður"
          v-if="
            loggedInUserHasAnyPermission('write_application') &&
            (availableStatuses[data.status].includes('NEW') ||
              availableStatuses[data.status].includes('IN_PROGRESS') ||
              availableStatuses[data.status].includes('IN_PROGRESS_APPROVED') ||
              availableStatuses[data.status].includes('WITHDRAWN') ||
              availableStatuses[data.status].includes('CANCELLED') ||
              availableStatuses[data.status].includes('COMPLETED'))
          "
        >
          <b-dropdown-item
            v-if="availableStatuses[data.status].includes('NEW') && loggedInUserHasAnyPermission('write_application')"
            @click.prevent="applicationNewModal()"
            >Nýskráð</b-dropdown-item
          >
          <b-dropdown-item
            v-if="availableStatuses[data.status].includes('IN_PROGRESS') && loggedInUserHasAnyPermission('write_application')"
            @click.prevent="applicationInProgressModal()"
            >Í vinnslu</b-dropdown-item
          >
          <b-dropdown-item
            v-if="availableStatuses[data.status].includes('IN_PROGRESS_APPROVED') && loggedInUserHasAnyPermission('write_application')"
            @click.prevent="applicationInProgressApproveModal()"
            >Í vinnslu samþykkt</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              availableStatuses[data.status].includes('WITHDRAWN') &&
              loggedInUserHasAnyPermission('write_application') &&
              loggedInUserHasAnyPermission('write_approve_application')
            "
            @click.prevent="applicationWithdrawModal()"
            >Draga til baka</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              availableStatuses[data.status].includes('CANCELLED') &&
              loggedInUserHasAnyPermission('write_application') &&
              loggedInUserHasAnyPermission('write_approve_application')
            "
            @click.prevent="applicationCancelModal()"
            >Afskrá</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              availableStatuses[data.status].includes('COMPLETED') &&
              loggedInUserHasAnyPermission('write_application') &&
              loggedInUserHasAnyPermission('write_approve_application')
            "
            @click.prevent="applicationCompleteModal()"
            >Ráðning</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <b-card class="card-primary-header" v-if="application && data">
      <div slot="header">
        <div>Umsókn</div>
      </div>
      <application-applicant :item="application" :item2="applicationNationalRegistry" :id="id" @reload="doReload" />
      <application-registration :item="application" :item2="data" :id="id" @reload="doReload" />
      <application-contacts :item="data" @reload="doReload" />
      <b-row class="mt-4">
        <b-col> </b-col>
      </b-row>
    </b-card>
    <application-email :id="id" :reload="doReload" />
    <application-history :id="id" :reload="doReload" />

    <!--approve-application-modal ref="approveApplicationModal" @successful="loadList"></approve-application-modal-->
    <reject-application-modal ref="rejectApplicationModal" @successful="doReload"></reject-application-modal>
    <finish-application-modal ref="finishApplicationModal" @successful="doReload"></finish-application-modal>
    <application-in-progress-modal ref="applicationInProgressModal" @successful="doReload"></application-in-progress-modal>
    <application-in-progress-approved-modal
      ref="applicationInProgressApprovedModal"
      @successful="doReload"
    ></application-in-progress-approved-modal>
    <application-withdraw-modal ref="withdrawApplicationModal" @successful="doReload"></application-withdraw-modal>
    <application-complete-modal ref="completeApplicationModal" @successful="doReload"></application-complete-modal>
    <application-cancel-modal ref="cancelApplicationModal" @successful="doReload"></application-cancel-modal>
    <application-new-modal ref="applicationNewModal" @successful="doReload"></application-new-modal>
    <application-reset-full-modal ref="applicationResetFullModal" @successful="doReload"></application-reset-full-modal>
  </vinnuskoli-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import appl from '@/api/application';
import RejectApplicationModal from '@/components/application/RejectApplication.vue';
import FinishApplicationModal from '@/components/application/FinishApplication.vue';
import ApplicationInProgressModal from '@/components/application/ApplicationInProgressModal.vue';
import ApplicationWithdrawModal from '@/components/application/ApplicationWithdrawModal.vue';
import ApplicationCancelModal from '@/components/application/ApplicationCancelModal.vue';
import ApplicationCompleteModal from '@/components/application/ApplicationCompleteModal.vue';
import ApplicationNewModal from '@/components/application/ApplicationNewModal.vue';
import ApplicationInProgressApprovedModal from '@/components/application/ApplicationInProgressApprovedModal.vue';
import ApplicationApplicant from '@/components/application/ApplicationApplicant.vue';
import ApplicationRegistration from '@/components/application/ApplicationRegistration.vue';
import ApplicationContacts from '@/components/application/ApplicationContacts.vue';
import ApplicationHistory from '@/components/application/ApplicationHistory.vue';
import ApplicationEmail from '@/components/application/ApplicationEmail.vue';
import ApplicationResetFullModal from '@/components/application/ApplicationResetFullModal.vue';

export default {
  name: 'Application',
  components: {
    RejectApplicationModal,
    FinishApplicationModal,
    ApplicationApplicant,
    ApplicationRegistration,
    ApplicationContacts,
    ApplicationHistory,
    ApplicationEmail,
    ApplicationInProgressModal,
    ApplicationNewModal,
    ApplicationWithdrawModal,
    ApplicationCancelModal,
    ApplicationCompleteModal,
    ApplicationInProgressApprovedModal,
    ApplicationResetFullModal,
  },
  computed: {
    ...mapGetters(['loggedInUserHasAnyPermission']),
  },
  data() {
    return {
      id: null,
      loading: false,
      error: false,
      data: null,
      application: null,
      applicationNationalRegistry: null,
      availableStatuses: {
        NEW: ['IN_PROGRESS', 'IN_PROGRESS_APPROVED', 'SEMI_ACCEPTED', 'ACCEPTED', 'REJECTED', 'CANCELLED', 'WITHDRAWN'],
        IN_PROGRESS: ['NEW', 'IN_PROGRESS', 'IN_PROGRESS_APPROVED', 'SEMI_ACCEPTED', 'ACCEPTED', 'REJECTED', 'CANCELLED', 'WITHDRAWN'],
        IN_PROGRESS_APPROVED: ['NEW', 'SEMI_ACCEPTED', 'ACCEPTED', 'REJECTED', 'CANCELLED', 'WITHDRAWN'],
        SEMI_ACCEPTED: ['ACCEPTED'],
        ACCEPTED: ['COMPLETED'],
        REJECTED: [],
        CANCELLED: [],
        WITHDRAWN: [],
        COMPLETED: [],
      },
    };
  },
  methods: {
    getStatusName(status) {
      switch (status) {
        case 'NEW':
          return 'Nýskráð';
        case 'SEMI_ACCEPTED':
          return 'Afgreidd að hluta';
        case 'ACCEPTED':
          return 'Afgreidd';
        case 'REJECTED':
          return 'Hafnað';
        case 'CANCELLED':
          return 'Afskráð';
        case 'IN_PROGRESS':
          return 'Í vinnslu';
        case 'IN_PROGRESS_APPROVED':
          return 'Í vinnslu samþykkt';
        case 'WITHDRAWN':
          return 'Dregin til baka';
        case 'COMPLETED':
          return 'Ráðning';
        default:
          return '';
      }
    },
    async doReload() {
      await this.loadApplication();
    },
    // Modal gluggar
    applicationApproveModal() {
      this.$router.push({ name: 'ApproveApplication', params: { id: this.id } });
    },
    applicationRejectModal() {
      const items = [];
      items.push(this.data);
      this.$refs.rejectApplicationModal.show(items);
    },
    applicationFinishModal() {
      const items = [];
      items.push(this.data);
      this.$refs.finishApplicationModal.show(items);
    },
    async applicationDelete() {
      const conf = confirm('Ertu viss alveg viss um að þú viljir eyða umsókninni'); //eslint-disable-line
      if (conf) {
        await appl.applicationDelete(this.id);
        this.displaySuccess('Umsóknir eytt');
        this.$router.push({ name: 'ApplicationList' });
      }
    },
    applicationInProgressModal() {
      const items = [];
      items.push(this.data);
      this.$refs.applicationInProgressModal.show(items);
    },
    applicationInProgressApproveModal() {
      const items = [];
      items.push(this.data);
      this.$refs.applicationInProgressApprovedModal.show(items);
    },
    applicationWithdrawModal() {
      const items = [];
      items.push(this.data);
      this.$refs.withdrawApplicationModal.show(items);
    },
    applicationCancelModal() {
      const items = [];
      items.push(this.data);
      this.$refs.cancelApplicationModal.show(items);
    },
    applicationCompleteModal() {
      const items = [];
      items.push(this.data);
      this.$refs.completeApplicationModal.show(items);
    },
    applicationNewModal() {
      const items = [];
      items.push(this.data);
      this.$refs.applicationNewModal.show(items);
    },
    applicationResetFullModal() {
      this.$refs.applicationResetFullModal.show(this.data);
    },
    async loadApplication() {
      this.loading = true;
      this.data = null;
      this.application = null;
      this.error = false;

      try {
        const response = await this.$applicationApi.applicationRetrieve({
          uuid: this.id,
        });

        this.data = response.data;
        this.application = response.data;
      } catch (e) {
        this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    async loadNationalRegistry() {
      try {
        const response = await appl.applicationNationalRegistry(this.id);
        this.applicationNationalRegistry = response.data;
      } catch (e) {
        this.$log.error(e);
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  created() {
    this.id = this.$route.params.id;
    this.loadApplication();
    this.loadNationalRegistry();
  },
};
</script>

<style lang="scss">
@import '../style/variables';
.card-primary-header {
  .card-header {
    background-color: $primary;
    color: #fff;
    font-size: 18px;
  }
}
h5.header {
  font-weight: 100;
}
</style>
